import './style/drone-A16.scss'

$('.product-video-box .watch-video').click(function () {
  $('.product-video-box .video-mask').show()
  $('.product-video-box .video-mask video').attr('src','https://static.qifeizn.com/resources/os/videos/new-A16.mp4');
})
$('.product-video-box .video-close').click(function () {
  $('.product-video-box .video-mask').hide()
  $('.product-video-box .video-mask video').attr('src','');
})
$('.variable-spray-box .watch-video').click(function () {
  $('.variable-spray-box .video-mask').show()
  $('.variable-spray-box .video-mask video').attr('src','https://static.qifeizn.com/resources/os/videos/new-A16-variable-spray.mp4');
})
$('.variable-spray-box .video-close').click(function () {
  $('.variable-spray-box .video-mask').hide()
  $('.variable-spray-box .video-mask video').attr('src','');
})
